import { render, staticRenderFns } from "./kdniao.vue?vue&type=template&id=72de4f12&scoped=true"
import script from "./kdniao.vue?vue&type=script&lang=js"
export * from "./kdniao.vue?vue&type=script&lang=js"
import style0 from "./kdniao.vue?vue&type=style&index=0&id=72de4f12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de4f12",
  null
  
)

export default component.exports